<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Configurações gerais de ordem de serviço</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Numeração, situações e regras de execução das ordens
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="section-container">
        <app-loading-box height="22" width="260" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="45%" marginTop="16"></app-loading-box>
        <app-loading-box height="22" width="45%" marginTop="12"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
        <app-loading-box height="30" width="260" marginTop="32"></app-loading-box>
        <app-loading-box height="72" width="100%" marginTop="16"></app-loading-box>
        <app-loading-box height="22" width="55%" marginTop="16"></app-loading-box>
      </div>
    } @else {
      <form [formGroup]="form">
        <div class="section-container">
          <div class="row conteudo-secao">
            <div class="col-12">
              <div class="subsection-title" id="numeracao-titulo">Numeração das ordens de serviço</div>
              <mat-radio-group formControlName="idTipoNumeracaoDocumento" aria-labelledby="numeracao-titulo"
                class="d-flex flex-column gap-3">
                @for (t of opcoesTipoNumeracao; track t.idTipoNumeracaoDocumento) {
                <mat-radio-button [value]="t.idTipoNumeracaoDocumento">
                  {{ t.descricao }}
                  @if (t.textoApoio) {
                  <span class="sub-section-sub-title d-block m-0">{{ t.textoApoio }}</span>
                  }
                </mat-radio-button>
                }
              </mat-radio-group>
              <p class="sub-section-sub-title mt-3 mb-0">Ordens de serviço já emitidas não são renumeradas.</p>
            </div>

            <div class="col-12 mt-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Prazo padrão de execução (dias)</mat-label>
                <input matInput type="number" class="no-spinner" min="0" step="1"
                  formControlName="prazoPadraoExecucaoDias">
                @if (prazoInvalido) {
                <mat-error>Informe um número inteiro maior ou igual a zero.</mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <div class="section-title conteudo-secao mt-3">
            <span>Situações da ordem de serviço</span>
          </div>

          <div class="row conteudo-secao">
            <div class="col-12">
              <app-alert-card type="info" icon="view_kanban">
                As situações, o fluxo de movimentação e as permissões por perfil são definidos em Kanban de ordem
                de serviço.
                <div alertActions>
                  <button mat-button type="button" class="btn-section" (click)="abrirConfiguracaoKanban()">
                    Abrir configuração
                  </button>
                </div>
              </app-alert-card>
            </div>

            <div class="col-12 mt-3">
              <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirObservacoesInternasTecnico">
                Imprimir observações internas na via do técnico
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</div>

<app-footer-action
  [isLoadingSalvar]="isSaving"
  [isSalvarDisabled]="!configCarregada || isLoading"
  (cancelar)="voltar()"
  (salvar)="salvar()">
</app-footer-action>
